import React from "react";
import { useNavigate } from "react-router-dom";
import Typography from "style-guide/component/Typography";
import Button from "style-guide/component/Button";

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/");
  };

  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-gray-50 text-center px-4">
      <Typography
        variant="Heading 1"
        className="text-4xl font-bold text-gray-800 mb-4"
        text="404 - Page Not Found"
      />
      <Typography
        variant="Base"
        className="text-gray-600 mb-6 max-w-md"
        text="Sorry, the page you are looking for does not exist or has been moved."
      />
      <Button type="Primary" buttonText="Go to Home" onClick={handleGoHome} />
    </div>
  );
};

export default NotFound;
